import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
	selector: 'app-assessment-proto-popup',
	standalone: true,
	imports: [],
	templateUrl: './assessment-proto-popup.component.html',
	styleUrl: './assessment-proto-popup.component.scss'
})
export class AssessmentProtoPopupComponent {


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<AssessmentProtoPopupComponent>,
		private router: Router
	) { }


	closePopup() {
		if (this.data?.isFromMockTest) {
			this.dialogRef.close();
			this.router.navigate(['/student-dashboard/placement-prep']);
			return;
		}
		if (this.data?.isFromStudentDashboard) {
			this.dialogRef.close();
			this.router.navigate(['student-dashboard/jobs/my-applications']);
			return;
		}
		localStorage.clear();
		this.dialogRef.close();
		this.router.navigate(['/']);
	}

}
